import { ActionIcon, Flex, Menu, Text, Tooltip } from '@mantine/core';
import { IconEdit, IconEye, IconLogin, IconLogout, IconTrash } from '@tabler/icons-react';
import BadgeStatus from 'components/Badge/BadgeStatus';
import Dates from 'components/Dates';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { Course } from 'types/lcms/courses';

export const column = (
  handleView?: (_data: Course) => void,
  handleEdit?: (_data: Course) => void,
  handleDelete?: (_data: Course) => void,
  handleCheckIn?: (_data: Course) => void,
  handleCheckOut?: (_data: Course) => void
) => [
  {
    heading: 'Course Name',
    props: ({ courseName, msLCMSCourseID }: Course) => (
      <Link to={`/app/lcms/courses/${msLCMSCourseID}`} style={{ textDecoration: 'none' }}>
        <Text c={'primary.9'} fz={14} fw={500}>
          {courseName}
        </Text>
      </Link>
    ),
    sortable: true,
    active: true,
    disabled: true,
    id: 'courseName'
  },
  // {
  //   heading: 'Schedule',
  //   props: ({ schedule }: Course) => (
  //     <Dates type='range' date={[schedule.startDate, schedule.endDate]} dateFormat='dateNameTime' />
  //   ),
  //   active: true,
  //   sortable: false
  // },

  {
    heading: 'Course Category',
    props: 'courseCategory',
    sortable: true,
    active: true,
    id: 'courseCategory'
  },
  {
    heading: 'Competency Category',
    props: 'competencyCategory',
    sortable: true,
    active: true,
    id: 'competencyCategory'
  },
  {
    heading: 'Start Revise By',
    props: ({ checkInBy }: Course) => <Text>{checkInBy?.name || '-'}</Text>,
    sortable: true,
    active: true,
    id: 'checkInBy'
  },
  {
    heading: 'Start Revise Time',
    props: ({ checkInBy }: Course) => (
      <Dates date={checkInBy?.checkInDateTime ?? ''} dateFormat='dateNameTime' locale='en' />
    ),
    sortable: true,
    active: true,
    id: 'checkInBy'
  },
  {
    heading: 'End Revise By',
    props: ({ checkOutBy }: Course) => <Text>{checkOutBy?.name ?? '-'}</Text>,
    sortable: true,
    active: true,
    id: 'checkOutBy'
  },
  {
    heading: 'End Revise Time',
    props: ({ checkOutBy }: Course) => (
      <Dates date={checkOutBy?.checkOutDateTime ?? ''} dateFormat='dateNameTime' locale='en' />
    ),
    sortable: true,
    active: true,
    id: 'checkInBy'
  },
  {
    heading: 'Created By',
    props: 'createdBy',
    sortable: true,
    active: true,
    id: 'createdBy'
  },
  {
    heading: 'Created At',
    props: ({ createdAt }: Course) => (
      <Dates date={createdAt ?? ''} dateFormat='dateNameTime' locale='en' />
    ),
    sortable: true,
    active: true,
    id: 'createdAt'
  },
  {
    heading: 'Status',
    props: ({ status }: Course) => (
      <BadgeStatus status={(status as any) ?? 'draft'} styleVariant='solid' />
    ),
    sortable: true,
    active: true,
    id: 'status'
  },
  {
    heading: 'Action',
    props: (row: Course) => {
      const { checkInBy, checkOutBy, status } = row;
      let showTheCheckIn = false;
      if (!checkInBy?.checkInDateTime && !checkOutBy?.checkOutDateTime) {
        showTheCheckIn = true;
      } else if (checkInBy?.checkInDateTime && !checkOutBy?.checkOutDateTime) {
        showTheCheckIn = false;
      } else if (
        checkOutBy &&
        dayjs(checkInBy.checkInDateTime).isAfter(dayjs(checkOutBy.checkOutDateTime))
      ) {
        showTheCheckIn = false;
      } else if (
        checkOutBy &&
        dayjs(checkInBy.checkInDateTime).isBefore(dayjs(checkOutBy.checkOutDateTime))
      ) {
        showTheCheckIn = true;
      }

      let showTheCheckOut = false;
      if (
        checkInBy?.checkInDateTime &&
        (!checkOutBy?.checkOutDateTime ||
          dayjs(checkInBy.checkInDateTime).isAfter(dayjs(checkOutBy.checkOutDateTime)))
      ) {
        showTheCheckOut = true;
      } else if (
        checkOutBy &&
        dayjs(checkInBy.checkOutDateTime).isAfter(dayjs(checkOutBy.checkInDateTime))
      ) {
        showTheCheckOut = false;
      }
      if (status === 'Deleted') return null;

      return (
        <Menu shadow='md'>
          <Flex gap={4} justify={'flex-end'}>
            {handleCheckIn && showTheCheckIn && (
              <Tooltip label={'Start revise on Beelajar LMS'}>
                <ActionIcon variant='transparent' c={'grey.5'} onClick={() => handleCheckIn(row)}>
                  <IconLogin />
                </ActionIcon>
              </Tooltip>
            )}
            {handleCheckOut && showTheCheckOut && (
              <Tooltip label={'End revise on Beelajar LMS'}>
                <ActionIcon variant='transparent' c={'red.5'} onClick={() => handleCheckOut(row)}>
                  <IconLogout />
                </ActionIcon>
              </Tooltip>
            )}
            {handleView && (
              <Tooltip label={'View Detail'}>
                <ActionIcon variant='transparent' c={'grey.5'} onClick={() => handleView(row)}>
                  <IconEye />
                </ActionIcon>
              </Tooltip>
            )}
            {handleEdit && (
              <Tooltip label={'Edit'}>
                <ActionIcon
                  variant='transparent'
                  c={showTheCheckOut ? 'grey.2' : 'grey.5'}
                  disabled={Boolean(showTheCheckOut)}
                  onClick={() => handleEdit(row)}
                >
                  <IconEdit />
                </ActionIcon>
              </Tooltip>
            )}
            {handleDelete && (
              <Tooltip label={'Delete'}>
                <ActionIcon
                  variant='transparent'
                  c={showTheCheckOut ? 'grey.2' : 'grey.5'}
                  disabled={Boolean(showTheCheckOut)}
                  onClick={() => handleDelete(row)}
                >
                  <IconTrash />
                </ActionIcon>
              </Tooltip>
            )}
          </Flex>
        </Menu>
      );
    },
    active: true
  }
];
